import { EventEmitter } from '@angular/core';
import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dialog-edit-block',
  templateUrl: './dialog-edit-block.component.html',
  styleUrls: ['./dialog-edit-block.component.scss']
})
export class DialogEditBlockComponent {
  
  public onDelete = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<DialogEditBlockComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onDeleteClick() {
    this.onDelete.emit();
    this.dialogRef.close();
  }

}
